import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatTabsModule } from '@angular/material/tabs';
import { SharedModule } from '../shared/shared.module';
import { DeadLettersComponent } from './components/dead-letters/dead-letters.component';
import { DeadLetterFiltersComponent } from './components/dead-letter-filters/dead-letter-filters.component';
import { DeadLetterBulkActionsComponent } from './components/dead-letter-bulk-actions/dead-letter-bulk-actions.component';
import { DeadLetterListComponent } from './components/dead-letter-list/dead-letter-list.component';
import { DeadLetterDetailDialogComponent } from './components/dead-letter-detail-dialog/dead-letter-detail-dialog.component';
import { DeadLetterDetailOverviewComponent } from './components/dead-letter-detail-overview/dead-letter-detail-overview.component';
import { ExpandableSectionComponent } from './components/expandable-section/expandable-section.component';
import { DeadLetterDiagnosticsSectionComponent } from './components/dead-letter-diagnostics-section/dead-letter-diagnostics-section.component';
import { DeadLetterCompanySectionComponent } from './components/dead-letter-company-section/dead-letter-company-section.component';
import { DeadLetterTreatmentGroupSectionComponent } from './components/dead-letter-treatment-group-section/dead-letter-treatment-group-section.component';
import { DeadLetterLogSectionComponent } from './components/dead-letter-log-section/dead-letter-log-section.component';
import { JsonHighlightPipe } from './pipes/json-highlight.pipe';
import { StackTraceHighlightPipe } from './pipes/stack-trace-highlight.pipe';

@NgModule({
  declarations: [
    DeadLettersComponent,
    DeadLetterFiltersComponent,
    DeadLetterBulkActionsComponent,
    DeadLetterListComponent,
    DeadLetterDetailDialogComponent,
    DeadLetterDetailOverviewComponent,
    ExpandableSectionComponent,
    DeadLetterDiagnosticsSectionComponent,
    DeadLetterCompanySectionComponent,
    DeadLetterTreatmentGroupSectionComponent,
    DeadLetterLogSectionComponent,
    JsonHighlightPipe,
    StackTraceHighlightPipe
  ],
  imports: [
    CommonModule,
    SharedModule,
    ScrollingModule,
    MatFormFieldModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatTabsModule
  ]
})
export class DeadLettersModule { }
